/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit_TitleInputs */

const en_to_typescript_pit_title = /** @type {(inputs: To_Typescript_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Pitfalls`)
};

const ko_to_typescript_pit_title = /** @type {(inputs: To_Typescript_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 겪는 함정`)
};

const ja_to_typescript_pit_title = /** @type {(inputs: To_Typescript_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある落とし穴`)
};

/**
* | output |
* | --- |
* | "Common Pitfalls" |
*
* @param {To_Typescript_Pit_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit_title = /** @type {((inputs?: To_Typescript_Pit_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit_title(inputs)
	if (locale === "ko") return ko_to_typescript_pit_title(inputs)
	return ja_to_typescript_pit_title(inputs)
});